import React from 'react';
import {HashRouter as Router, Switch, Route, Redirect} from 'react-router-dom';
import App from '../components/Home/Home';
import Demo from '../components/Demo/Demo';
import Icons from '../components/Icons/Icons';
import Dialog from '../components/Dialog/Dialog';
import Swiper from '../components/Swiper/Swiper';
import NotFound from '../components/Common/NotFound';

const Routes = () => (
    <Router>
        <div className="app">
            <Switch>
                <Route path="/" exact component={App} />
                <Route path="/demo" component={Demo} />
                <Route path="/icons" component={Icons} />
                <Route path="/dialog" component={Dialog} />
                <Route path="/swiper" component={Swiper} />
                <Route path="/404" component={NotFound} />
                <Redirect from="*" to="/404" />
            </Switch>
        </div>
    </Router>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/index.js